import React, { PropTypes } from 'react';
import ExpandableListItem from 'main/components/activityAudit/expandableListItem';
import ItemNumber from 'main/components/activityAudit/itemNumber';
import ItemTitle from 'main/components/activityAudit/itemTitle';
import ItemTimeStamp from 'main/components/activityAudit/itemTimeStamp';
import {
  WithTooltip,
  Avatar as UserAvatar,
} from '@shoflo-rundown/polymer.legacy';
import HistoryButton from 'main/components/activityAudit/historyButton';
import RestoreButton from 'main/components/activityAudit/restoreButton';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import classNames from 'classnames';

const fieldTypes = ['title', 'description', 'column'];

export default React.createClass({
  propTypes: {
    fieldType: PropTypes.string,
    user: PropTypes.object,
    item: PropTypes.object,
    changes: PropTypes.string,
    displayHistoryButton: PropTypes.bool,
    displayRestoreButton: PropTypes.bool,
    onHistoryClick: PropTypes.func,
    onRestoreClick: PropTypes.func,
    onNumberClick: PropTypes.func,
    prefix: PropTypes.string,
    suffix: PropTypes.string,
    possessive: PropTypes.string,
    action: PropTypes.string,
  },

  getDefaultProps() {
    return {
      prefix: 'added',
      suffix: '',
      possessive: '',
      action: '',
    };
  },

  render() {
    const {
      fieldType,
      item,
      changes,
      onNumberClick,
      prefix,
      suffix,
      possessive,
      action,
    } = this.props;

    const title = item.get('itemTitle'),
      number = item.get('itemNumber'),
      createdOn = item.get('createdOn');

    const itemClasses = classNames('af-list-item', {
      expanded: typeof changes !== 'undefined',
    });

    let wrapperClasses = 'af-list-item-wrapper',
      actionClasses = 'af-list-item-action-icon';

    const itemTitle = <ItemTitle title={title} />;

    let itemNumberNode = (
      <ItemNumber
        number={number}
        onClick={onNumberClick}
        prefix={prefix}
        type="Item"
      />
    );

    /**
     * Define Restore and History Buttons
     */
    let restoreButtonNode = this._getRestoreButton();
    let historyButtonNode = this._getHistoryButton();

    if (restoreButtonNode && historyButtonNode)
      actionClasses = 'af-list-item-action-icons';

    /**
     * TODO: Need to do additional refactoring to figure out a better solution
     * for handling deleted rows
     */
    if (number === '---') {
      actionClasses = 'af-list-item-action-icon';

      //Restore button should not be removed for deleted rows
      if (prefix !== 'Deleted ') restoreButtonNode = null;
      historyButtonNode = null;

      itemNumberNode = <ItemNumber deleted />;
    }

    if (prefix == 'Deleted ' || prefix == 'cut ') {
      itemNumberNode = (
        <ItemNumber
          number={''}
          onClick={onNumberClick}
          prefix={prefix}
          type={'Item '}
        />
      );
    }

    if (suffix) {
      itemNumberNode = (
        <ItemNumber
          number={number}
          onClick={onNumberClick}
          possessive={possessive}
          prefix={prefix}
          suffix={suffix}
          type="Item"
        />
      );
    }

    let details = (
      <span>
        {itemNumberNode}
        {itemTitle}
        <div className="af-list-item-action">{action}</div>
      </span>
    );

    if (fieldTypes.indexOf(fieldType) !== -1) {
      wrapperClasses += ' af-list-item-wrapper-minimal';
      details = null;
    }

    const cellFormatting = item.getIn(['payload', 'changes', 'format'])
      ? item.getIn(['payload', 'changes', 'format'])
      : null;

    return (
      <div className={wrapperClasses}>
        <ItemTimeStamp createdOn={createdOn} />
        <div className={actionClasses}>
          <WithTooltip
            placement="top"
            delay={0}
            tip={TooltipConstants.CSActivityFeedListIcon}
          >
            <span>{historyButtonNode}</span>
          </WithTooltip>
          <WithTooltip
            placement="top"
            delay={0}
            tip={TooltipConstants.CSActivityFeedUndoIcon}
          >
            <span>{restoreButtonNode}</span>
          </WithTooltip>
        </div>
        <div className={itemClasses}>
          <UserAvatar user={item.get('user').toJS()} />
          {details}
          <ExpandableListItem changes={changes} format={cellFormatting} />
        </div>
      </div>
    );
  },

  _getRestoreButton() {
    let { prefix, displayRestoreButton, onRestoreClick } = this.props;

    let titleChanges = this._getTitleChanges(),
      descriptionChanges = this._getDescriptionChanges();

    /**
     * Show restore button for item title/descriptions changes and deleted rows
     */
    return displayRestoreButton &&
      (prefix === 'Deleted ' || titleChanges || descriptionChanges) ? (
      <RestoreButton onClick={onRestoreClick} />
    ) : null;
  },

  _getHistoryButton() {
    let { displayHistoryButton, onHistoryClick } = this.props;

    let titleChanges = this._getTitleChanges(),
      descriptionChanges = this._getDescriptionChanges();

    /**
     * Show history button for item title/descriptions changes and deleted rows
     */
    return displayHistoryButton && (titleChanges || descriptionChanges) ? (
      <HistoryButton onClick={onHistoryClick} />
    ) : null;
  },

  _getTitleChanges() {
    return this._getItemChangesField('rteTitleState');
  },

  _getDescriptionChanges() {
    return this._getItemChangesField('rteDescriptionState');
  },

  _getItemChangesField(field) {
    let { item } = this.props;

    return item.getIn(['payload', 'changes', field]);
  },
});
